module.exports = __webpack_public_path__ + "static/rice-3a7bcc8b2cbf18c385288ca025cf3727.png";